import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }

import IndustryExpertise from '@/common/components/industry-expertise/IndustryExpertise.vue';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import IndustryExpertiseSide from '@/profile-creation-wizard/components/for-creation/ui/industrySkills/IndustryExpertiseSide.vue';
    import {IndustrySkill} from '@/profile-creation-wizard/types';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, inject, onBeforeMount, onBeforeUnmount, onMounted, reactive, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import {useStore} from 'vuex';

    const maxSelection = 5;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IndustryExpertiseStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const industryExpertiseRepository = inject(DI.industryExpertiseRepository);
    const trackingRepository = inject(DI.trackingRepository);

    const creationForm = ref(store.getters[getters.creationForm]);
    const industry = ref<HTMLElement>(null);

    const isStepValid = computed(() => creationForm.value.industryExpertises.length > 0);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const state = reactive<{expertiseAvailable: IndustrySkill[]; isResponsive: boolean}>({
        expertiseAvailable: [],
        isResponsive: isAtResponsiveBreakpoint(),
    });

    onBeforeMount(async (): Promise<void> => {
        if (window.hj) {
            // Custom event Hotjar
            window.hj('event', 'profile_creation_details_page');
        }
        window.addEventListener('resize', refreshResponsive);
        await loadExpertisesAvailable();
    });

    onMounted((): void => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer('#details-industry-bottom-sheet', '', industry.value, 'div.profile-creation-wizard');
    });

    onBeforeUnmount((): void => window.removeEventListener('resize', refreshResponsive));

    async function loadExpertisesAvailable(): Promise<void> {
        const [expertises, error] = await industryExpertiseRepository!.loadExpertise();
        if (expertises && !error) {
            state.expertiseAvailable = expertises;
        }
    }

    function goNext(): void {
        trackingRepository?.track('industry-expertise-chosen-skills-strategy', {
            industrySkills: creationForm.value.industryExpertises.length,
        });
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    function handleExpertisesChanged(expertises: IndustrySkill[]) {
        store.commit(mutations.updateIndustryExpertises, expertises);
    }

    function handleMaxSelectionReached() {
        pushVJoySnackbar({
            props: {
                message: msg('profile.creation.completion.wizard.industry.expertise.error.limit', maxSelection),
                level: 'error',
            },
        });
    }

    function refreshResponsive(): void {
        state.isResponsive = isAtResponsiveBreakpoint();
    }

    function isAtResponsiveBreakpoint(): boolean {
        return window.innerWidth < 996;
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isStepValid.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "industry",
        ref: industry,
        class: "details-form__item"
      }, [
        _createVNode(StepItemTitle, {
          "is-optional": !_ctx.$store.state.isFunnelStrategy
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.industry.expertise.title')), 1)
          ]),
          _: 1
        }, 8, ["is-optional"]),
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.industry.expertise.regular.subtitle')), 1),
          _createElementVNode("a", {
            class: "open-bottom-sheet",
            onClick: openBottomSheet
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.industry.expertise.title')), 1)
        ]),
        _createVNode(IndustryExpertise, {
          responsive: state.isResponsive,
          "all-expertises": state.expertiseAvailable,
          "selected-expertises": creationForm.value.industryExpertises,
          "max-selection": maxSelection,
          "onIndustryExpertise:updated": handleExpertisesChanged,
          "onIndustryExpertise:maxSelectionReached": handleMaxSelectionReached
        }, null, 8, ["responsive", "all-expertises", "selected-expertises"])
      ], 512)
    ]),
    "step-side": _withCtx(() => [
      _createVNode(IndustryExpertiseSide)
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})